import * as type from './type';
export default {
    [type.SET_SKUID](state, skuId) {
        state.skuId = skuId;
    },
    [type.SET_ACTIVITYID](state, activityId) {
        state.activityId = activityId;
    },
    [type.SET_SKUNUM](state, skuNum) {
        state.skuNum = skuNum;
    },

}


// WEBPACK FOOTER //
// ./src/store/spell-buy/mutations.js